<template>
  <Teleport to="body">
    <Transition name="mhlm-modal">
      <div v-if="modelValue" class="mhlm-modal-bd">
        <div class="mhlm-modal" :style="{ maxWidth: maxWidth + 'px' }">
          <header class="mhlm-modal__hd">
            <div>
              <h3>{{ title }}</h3>
              <p v-if="subtitle" class="mhlm-modal__sub">{{ subtitle }}</p>
            </div>
            <button class="mhlm-modal__x" @click="$emit('update:modelValue', false)" aria-label="Cerrar">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </header>
          <div class="mhlm-modal__bd"><slot /></div>
          <footer v-if="$slots.footer" class="mhlm-modal__ft"><slot name="footer" /></footer>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
export default {
  name: 'MhlmModal',
  props: {
    modelValue: { type: Boolean, default: false },
    title:    { type: String, required: true },
    subtitle: { type: String, default: '' },
    maxWidth: { type: Number, default: 520 }
  },
  emits: ['update:modelValue']
};
</script>

<style>
.mhlm-modal-bd{
  position:fixed; inset:0; z-index:999;
  background:rgba(3,27,52,0.42); backdrop-filter:blur(2px);
  display:flex; align-items:center; justify-content:center;
  padding:20px;
}
.mhlm-modal{
  background:var(--surface); border-radius:14px;
  box-shadow:0 20px 60px rgba(3,27,52,0.3);
  width:100%; max-height:90vh;
  display:flex; flex-direction:column; overflow:hidden;
}
.mhlm-modal__hd{
  padding:18px 20px 14px;
  border-bottom:1px solid var(--border);
  display:flex; align-items:flex-start; justify-content:space-between; gap:12px;
}
.mhlm-modal__hd h3{ font-size:16px; font-weight:700; color:var(--tx-hi); margin:0; }
.mhlm-modal__sub{ font-size:12.5px; color:var(--tx-lo); margin:3px 0 0; }
.mhlm-modal__x{
  width:30px; height:30px; border:none; background:transparent;
  color:var(--tx-lo); cursor:pointer; border-radius:6px;
  display:flex; align-items:center; justify-content:center;
}
.mhlm-modal__x:hover{ background:var(--acc-xlt); color:var(--accent); }
.mhlm-modal__bd{ padding:20px; overflow-y:auto; flex:1; }
.mhlm-modal__ft{
  padding:14px 20px; border-top:1px solid var(--border);
  display:flex; justify-content:flex-end; gap:8px;
  background:var(--acc-xlt);
}
.mhlm-modal-enter-active,.mhlm-modal-leave-active{ transition:opacity .2s; }
.mhlm-modal-enter-active .mhlm-modal,.mhlm-modal-leave-active .mhlm-modal{
  transition:transform .22s cubic-bezier(.4,0,.2,1);
}
.mhlm-modal-enter-from,.mhlm-modal-leave-to{ opacity:0; }
.mhlm-modal-enter-from .mhlm-modal,.mhlm-modal-leave-to .mhlm-modal{ transform:translateY(12px) scale(.98); }
</style>
